import "./TranslateDashboard.css";
import { useConstants } from "../../constant/constantProvider";

// components 
import CardItem from "../CardItem/CardItem";

// assets 
import TRANSLATE_MAIN_ICON from "../../assets/images/translate-main-icon.svg";
import TRANSLATION_DOCS_ICON from "../../assets/images/translate-docs.svg";
import TRANSLATION_TEXT_ICON from "../../assets/images/translate-text.svg";

const TranslateDashboard = ({ primaryButtonClick }) => {
  const {
    TRANSLATE_DESCRIPTION,
    WELCOME_TRANSLATE_TEXT,
    GET_STARTED,
    TRANSLATE_TEXT,
    TRANSLATE_DOCS,
    TRANSLATE_TEXT_SUBTITLE,
    TRANSLATE_DOCS_SUBTITLE,
  } = useConstants();

  const cards = [
    {
      icon: TRANSLATION_TEXT_ICON,
      title: TRANSLATE_TEXT,
      subtitle: TRANSLATE_TEXT_SUBTITLE,
    },
    {
      icon: TRANSLATION_DOCS_ICON,
      title: TRANSLATE_DOCS,
      subtitle: TRANSLATE_DOCS_SUBTITLE,
    },
  ];
  return (
    <div className="translate-dashboard-content">
      <div className="translate-header">
        <div className="translate-icon">
          <img src={TRANSLATE_MAIN_ICON} alt="translation-icon"></img>
        </div>
        <span className="translation-text">{WELCOME_TRANSLATE_TEXT}</span>
        <p>{TRANSLATE_DESCRIPTION}</p>
      </div>
      <div className="cards card-container">
        {cards?.map((card, idx) => (
          <CardItem
            key={idx}
            icon={card.icon}
            title={card.title}
            subtitle={card.subtitle}
          />
        ))}
      </div>
      <button
        className="button-style primary-start-button"
        type="button"
        onClick={primaryButtonClick}
      >
        {GET_STARTED}
      </button>
    </div>
  );
};

export default TranslateDashboard;
